import type { ReactElement } from "react";
import { documentsIndexedFixture } from "./fixtures";
import type { MetricGranularity } from "./fixtures";
import { GrowthChart } from "./GrowthChart";

export interface DocumentsIndexedChartProps {
  /** Granularity selected by the screen's shared `PeriodSelector`. */
  readonly granularity: MetricGranularity;
}

/**
 * Documents-indexed-per-period growth chart (ISSUE-352 rescoping, T3),
 * channel-split (mobile vs. Telegram), fixture-backed via
 * `documentsIndexedFixture`. Takes `granularity` as a prop rather than owning
 * a `PeriodSelector` itself — the screen assembly step wires one shared
 * selector to both T3 charts (Implementation Plan step 3).
 */
export function DocumentsIndexedChart({ granularity }: DocumentsIndexedChartProps): ReactElement {
  return (
    <GrowthChart
      title="Documents indexed"
      granularity={granularity}
      envelope={documentsIndexedFixture[granularity]}
      isFixture
    />
  );
}
